export enum TagCategoryType {
  Default = 'default',
  Highlight = 'highlight',
  Confirmed = 'confirmed',
  NotConfirmed = 'not-confirmed',
}

export enum TagCategorySize {
  MD = 'md',
  RG = 'rg',
}
